import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { QuoteTaxRepository } from '../application/QuoteTaxRepository'

export function createResilientQuoteTaxRepository(
  primary: QuoteTaxRepository,
  fallback: QuoteTaxRepository,
): QuoteTaxRepository {
  return {
    async listProfiles() {
      try {
        return await primary.listProfiles()
      } catch (error) {
        reportUnexpectedError(error, { feature: 'settings', operation: 'quote-taxes-list', fallback: true })
        const result = await fallback.listProfiles()
        return {
          ...result,
          meta: {
            ...result.meta,
            source: 'fixture-fallback',
            fallbackReason: 'QUOTE_TAX_PROFILES_REMOTE_UNAVAILABLE',
          },
        }
      }
    },
    activateProfile(command) {
      return primary.activateProfile(command)
    },
  }
}
